var images = {
    chaselistLogo: require("../assets/images/chaselist-logo.png").default,
    user: require("../assets/images/user-image.png").default,
    userBlue: require("../assets/images/user-fill-icon-blue.png").default,
    cityBackground: require("../assets/images/bg-images/bg-1.png").default,
    userMedium: require("../assets/images/user-square.png").default,
};
export default images;
